<div class="autosuggest">
  <div class="autosuggest__container">
    <div class="autosuggest__input-holder">
      <span (click)="toResultsPage()" class="autosuggest__ico"></span>
      <app-autosuggest-input
        (onBlur)="hideResults()"
        (onClear)="clearResults()"
        [placeholder]="'autoSuggest.Placeholder' | translate"
        (onQuery)="handleQuery($event)"
        (toResults)="toResultsPage()">
      </app-autosuggest-input>
    </div>
  </div>
</div>

<app-autosuggest-results tabindex="1" *ngIf="isShowResults" [isResponseCompleted]="isResponseCompleted" [results]="suggestions" [query]="query">
  <button tabindex="0" *ngIf="suggestions.length > MAX_RESULTS" class="suggestion suggestion--see-all" (click)="toResultsPage()">
    <div class="suggestion__content">
      {{ 'autoSuggest.AllResults' | translate }}
    </div>
  </button>
</app-autosuggest-results>
